import request from "./request"
import axios from "axios";
let langObj:any = []

const getList = async() => {
    const reult = await axios.get('/language.json')
    langObj = reult?.data || []
}
getList()

export const getLanguage = (name:any, language:any = null) => {
    if(!language) {
        language = localStorage.getItem('language') || 'English'
    }
    let title = name
    const list:any = langObj[name]
    if(list?.length > 0) {
        if(language === 'Chinese' && list[0]) {
            title = list[0]
        }
        if(language === 'English' && list[0]) {
            title = list[1]
        }
        if(language === 'Chinese_ft' && list[0]) {
            title = list[2]
        }
    } 
    return title
}

let translations:any = []
const getTranslations = async() => {
    if(request) {
        const result = await request.get('/api/translations/all')
        translations = result?.data || []
    }
}
getTranslations()
export const getTranslation = (name:any, language:any = null) => {
    if(!language) {
        language = localStorage.getItem('language') || 'Chinese'
    }
    let title = name
    const info:any = translations.find((p:any) => p.key === name)
    if(info) {
        if(language === 'Chinese') {
            title = info.zh
        }
        if(language === 'English') {
            title = info.en
        }
        if(language === 'Chinese_ft') {
            title = info.ft
        }

        if(!title) {
            title = info.zh
        }
    }
    return title
}

// 插件转换繁体
const OpenCC = require('opencc-js');
const converter = OpenCC.Converter({ from: 'cn', to: 'hk' });

export const getChineseFt = (name:any) => {
    let content = name
    if(name) {
        content = converter(name)
    }
    return content
}
